(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["malvice-pair-well"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('malvice-pair-well-list')) {
    customElements.define(
      'malvice-pair-well-list',
      class MalvicePairWellList extends HTMLElement {
        connectedCallback() {
          this.addEventListener('change', this.handleVariantChange);
        }

        disconnectedCallback() {
          this.removeEventListener('change', this.handleVariantChange);
        }

        handleVariantChange(event) {
          const select = event.target.closest('[data-pair-variant]');
          if (!select) return;

          const row = select.closest('[data-pair-row]');
          const option = select.selectedOptions[0];
          if (!row || !option) return;

          const price = row.querySelector('[data-pair-price]');
          const compareAt = row.querySelector('[data-pair-compare]');
          const saving = row.querySelector('[data-pair-saving]');
          const button = row.querySelector('[ref="addToCartButton"]');
          const image = row.querySelector('.malvice-pair-well__image');
          const addToCart = row.querySelector('add-to-cart-component');
          const onSale = option.dataset.onSale === 'true';

          if (price) price.textContent = option.dataset.price || '';
          if (compareAt) {
            compareAt.textContent = option.dataset.compareAt || '';
            compareAt.hidden = !onSale;
          }
          if (saving) {
            saving.textContent = `${saving.dataset.saveLabel || ''} ${option.dataset.saving || ''}`.trim();
            saving.hidden = !onSale;
          }
          if (button) button.disabled = option.dataset.available !== 'true';
          if (image && option.dataset.image) {
            image.src = option.dataset.image;
            image.srcset = option.dataset.image;
          }
          if (addToCart && option.dataset.image) {
            addToCart.dataset.productVariantMedia = option.dataset.image;
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["malvice-product-guide"] && !Shopify.designMode) return;
  try {
    if (!document.documentElement.hasAttribute('data-malvice-size-guide-ready')) {
    document.documentElement.setAttribute('data-malvice-size-guide-ready', '');
    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-malvice-size-chart-open]');
      if (opener) {
        var sizeDialog = document.getElementById(opener.getAttribute('data-malvice-size-chart-open'));
        if (sizeDialog && typeof sizeDialog.showModal === 'function') sizeDialog.showModal();
        return;
      }
      if (event.target.matches('.malvice-size-guide-dialog[open]')) event.target.close();
    });
  }
  } catch(e) { console.error(e); }
})();

})();
